import { useEasyPaisaStore } from '~/stores/easypaisa';

export const getUserAuthCodeResult = async (json: string) => {
	const store = useEasyPaisaStore();

	try {
		const result = JSON.parse(json) as { authCode?: string; status?: string };

		if (result?.status === 'SUCCESS' && result?.authCode) {
			store.authCode = result.authCode;
		}
	} catch (err) {
		console.error('getUserAuthCodeResult error:', err);
	}
};
